"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConnectedSigner = exports.useLazyConnectedSigner = exports.useGetConnectedSigner = exports.useProviderOrSigner = exports.useProvider = void 0;
var providers_1 = require("@ethersproject/providers");
var react_1 = require("react");
var use_contractkit_1 = require("./use-contractkit");
var useProvider = function () {
    var kit = use_contractkit_1.useContractKit().kit;
    var provider = kit.web3.currentProvider;
    return react_1.useMemo(function () {
        return new providers_1.Web3Provider(provider);
    }, [provider]);
};
exports.useProvider = useProvider;
var useProviderOrSigner = function () {
    var kit = use_contractkit_1.useContractKit().kit;
    var provider = exports.useProvider();
    return react_1.useMemo(function () {
        return kit.defaultAccount
            ? provider.getSigner(kit.defaultAccount)
            : provider;
    }, [provider, kit.defaultAccount]);
};
exports.useProviderOrSigner = useProviderOrSigner;
var useGetConnectedSigner = function () {
    var _a = use_contractkit_1.useContractKit(), kit = _a.kit, getConnectedKit = _a.getConnectedKit;
    var signer = exports.useProviderOrSigner();
    return react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextKit, nextProvider;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (kit.defaultAccount) {
                        return [2 /*return*/, signer];
                    }
                    return [4 /*yield*/, getConnectedKit()];
                case 1:
                    nextKit = _a.sent();
                    nextProvider = nextKit.web3
                        .currentProvider;
                    return [2 /*return*/, new providers_1.Web3Provider(nextProvider).getSigner(nextKit.defaultAccount)];
            }
        });
    }); }, [kit.defaultAccount, getConnectedKit, signer]);
};
exports.useGetConnectedSigner = useGetConnectedSigner;
var useLazyConnectedSigner = function () {
    var _a;
    var getConnectedSigner = exports.useGetConnectedSigner();
    var _b = react_1.useState(null), signer = _b[0], setSigner = _b[1];
    var getConnectedSignerCb = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var theSigner;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getConnectedSigner()];
                case 1:
                    theSigner = _a.sent();
                    setSigner(theSigner);
                    return [2 /*return*/, theSigner];
            }
        });
    }); }, [getConnectedSigner, setSigner]);
    return {
        signer: signer,
        getConnectedSigner: getConnectedSignerCb,
        address: (_a = signer === null || signer === void 0 ? void 0 : signer._address) !== null && _a !== void 0 ? _a : null,
    };
};
exports.useLazyConnectedSigner = useLazyConnectedSigner;
var useConnectedSigner = function () {
    var getConnectedSigner = exports.useGetConnectedSigner();
    var _a = react_1.useState(null), signer = _a[0], setSigner = _a[1];
    react_1.useEffect(function () {
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = setSigner;
                        return [4 /*yield*/, getConnectedSigner()];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [getConnectedSigner, setSigner]);
    return signer;
};
exports.useConnectedSigner = useConnectedSigner;
//# sourceMappingURL=ethers.js.map